module.exports = __webpack_public_path__ + "static/1-81cc732db8410de8a1552a3806c277d7.jpg";